import { graphql } from 'react-relay';
import { GraphQLReturn, graphQLSelector } from '@cherre-frontend/data-fetching';
import { getInitialDatasetsValuesQuery } from './__generated__/getInitialDatasetsValuesQuery.graphql';

export type InitialDatasetsValues =
  getInitialDatasetsValuesQuery['response']['sys_properties_flattened_union'][number];

export const getInitialDatasetsValues = graphQLSelector({
  query: graphql`
    query getInitialDatasetsValuesQuery($property_id: Int!) {
      sys_properties_flattened_union(
        where: { property_id: { _eq: $property_id } }
      ) {
        properties_batch_validation_rules(where: { is_active: { _eq: true } }) {
          batch_validation_rule_id
          validation_mode
        }
        properties_dataset_validation_rules(
          where: { is_active: { _eq: true } }
        ) {
          dataset_validation_rule_id
          validation_mode
        }
        investment_properties_dataset_validation_rules(
          where: { is_active: { _eq: true } }
        ) {
          dataset_validation_rule_id
          validation_mode
        }
        properties_datasets(where: { is_active: { _eq: true } }) {
          dataset_id
        }
      }
    }
  ` as GraphQLReturn<getInitialDatasetsValuesQuery>,
  mapResponse: ({
    sys_properties_flattened_union: [data],
  }): InitialDatasetsValues => {
    return data;
  },
});
